import React, { Component } from "react";
import { Modal, Button, Image, Spinner } from "react-bootstrap";

export default class UploadImageErrorModal extends Component {
  render() {
    const {
      confirmShow,
      confirmonHide,
      onUpload,
      ImgHeight,
      ImgWidth,
      loader,
    } = this.props;
    return (
      <div>
        <Modal
          centered
          bsSize="small"
          show={confirmShow}
          onHide={confirmonHide}
          className="UploadImageModal"
        >
          <Modal.Header className="header">
            <Modal.Title className="title">
              Upload a photo with higher resolution
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="body">
            <p className="sub-title">{`Photos must be at least 800 pixels in width and 1200 pixels in height. Please upload higher quality photo. Your photo was ${ImgWidth}x${ImgHeight}.`}</p>
          </Modal.Body>
          <Modal.Footer className="footer">
            <button className="cancel" onClick={confirmonHide}>
              Cancel
            </button>
            <button className="choose">
              {loader ? (
                <Spinner animation="border" className="spinner" />
              ) : (
                "Choose another photo"
              )}
              <input
                type="file"
                className="choose"
                onChange={(e) => onUpload(e)}
              />
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
